import { render, staticRenderFns } from "./ASLConsentPage.vue?vue&type=template&id=6dd28fe4&scoped=true"
import script from "./ASLConsentPage.vue?vue&type=script&lang=js"
export * from "./ASLConsentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../deps/0/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd28fe4",
  null
  
)

export default component.exports